import React from 'react';
import { Link } from 'react-router-dom';
import { Frown } from 'lucide-react';

const NotFoundPage = () => {
    return (
        // Use the deep gray background consistent with the Layout
        <div className="flex flex-col items-center justify-center min-h-[calc(100vh-64px)] bg-gray-950 p-6 text-center">
            
            <div className="p-10 bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full border border-teal-500/30">
                
                {/* Icon: Updated color to Teal */}
                <Frown className="w-16 h-16 mx-auto text-teal-400 mb-6" />
                
                {/* Error Code & Heading */}
                <h1 className="text-7xl font-extrabold text-white mb-3 tracking-tight">404</h1>
                <h2 className="text-3xl font-semibold text-gray-200 mb-4">Route Not Found</h2>
                
                <p className="text-lg text-gray-400 mb-8">
                    The requested path does not exist on this MVP. The blockchain is eternal, but our URL structure is finite.
                </p>
                
                <div className="space-y-4">
                    {/* Primary Action: Go to MVP Dashboard/Utility */}
                    <Link 
                        to="/dashboard" // Changed to the core MVP feature
                        className="block w-full px-6 py-3 bg-teal-600 text-white font-bold rounded-lg shadow-md hover:bg-teal-700 transition duration-150 transform hover:scale-[1.01]"
                    >
                        Go to MVP Dashboard
                    </Link>
                    
                    {/* Secondary Action: Contact for Help */}
                    <Link 
                        to="/contact" // Changed to the Contact/Feedback page
                        className="block w-full px-6 py-3 border border-indigo-500 text-indigo-400 font-semibold rounded-lg hover:bg-indigo-900 transition duration-150"
                    >
                        Report a Missing Page / Give Feedback
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
